import React from 'react';
import {  MuiGrid } from '../../ui/MaterialUIComponents';

import TimeSlot from './TimeSlotComponent'
class DayComponent extends React.Component {

  getTimeSlotArray(){
    let tarray = this.props.day.timeSlots.map((timeSlot,index) => {

      return <TimeSlot timeSlot={timeSlot}
      {...this.props}
      index = {index}
      />
    });

    return tarray;
  }
  render() {
    return (
            <MuiGrid>
              {this.getTimeSlotArray()}
           </MuiGrid>
          )
  }
}

export default DayComponent;
